module.exports = __webpack_public_path__ + "5d76472be2559f2274740e13bb1b2027.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/4.m4a
// module id = 973
// module chunks = 4